const btnToggle = document.querySelector(".js-search-toggle");
const searchBar = document.querySelector(".js-search-bar");
const navigation = document.querySelector("#navigation");

function openSearch() {
  document.documentElement.classList.add("search-open");
  searchBar.removeAttribute("hidden");
  searchBar.querySelector("input").focus();
  navigation.setAttribute("hidden", "");
  btnToggle.setAttribute("aria-expanded", "true");
}

function closeSearch() {
  searchBar.setAttribute("hidden", "");
  navigation.removeAttribute("hidden");
  btnToggle.setAttribute("aria-expanded", "false");
  document.documentElement.classList.remove("search-open");
}

function handleToggleClick(e) {
  e.preventDefault();
  const element = document.getElementById("search-terms");

  if (searchBar.hasAttribute("hidden")) {
    openSearch();
  } else {
    closeSearch();
  }
}

function handleDocumentClick(e) {
  if (!btnToggle.contains(e.target) && !searchBar.contains(e.target)) {
    closeSearch();
  }
}

if (btnToggle) {
  btnToggle.addEventListener("click", handleToggleClick);
  document.addEventListener("click", handleDocumentClick);
}
